import {
  BabaSpecialOffer,
  BagelCodeSpecialOffer,
  BanditosSpecialOffer,
  BingoPopSpecialOffer,
  CashFrenzySpecialOffer,
  CashmanCasinoSpecialOffer,
  ClassicVegasSlotsSpecialOffer,
  DecaSpecialOffer,
  DefaultStudioSpecialOffer,
  DoubleHitCasinoSpecialOffer,
  DrimageSpecialOffer,
  FabelTownSpecialOffer,
  GennmuSpecialOffer,
  HugeSpecialOffer,
  JunesJourneySpecialOffer,
  LoadCompleteSpecialOffer,
  LocoBingoSpecialOffer,
  MatchMastersSpecialOffer,
  Me2onSpecialOffer,
  MightyFuSpecialOffer,
  PipaSpecialOffer,
  PlaySimpleSpecialOffer,
  PokerFaceSpecialOffer,
  ProductMadnessSpecialOffer,
  RoyalMatchSpecialOffer,
  SpinXSpecialOffer
} from '@appcharge/shared-ui';

import { ESpecialOfferInternalViewModel } from '../constants/enums';

export const mapSpecialOffers: Record<ESpecialOfferInternalViewModel, any> = {
  [ESpecialOfferInternalViewModel.HUGE]: HugeSpecialOffer,
  [ESpecialOfferInternalViewModel.MATCH_MASTERS]: MatchMastersSpecialOffer,
  [ESpecialOfferInternalViewModel.POKER_FACE]: PokerFaceSpecialOffer,
  [ESpecialOfferInternalViewModel.BAGELCODE]: BagelCodeSpecialOffer,
  [ESpecialOfferInternalViewModel.LOCO_BINGO]: LocoBingoSpecialOffer,
  [ESpecialOfferInternalViewModel.ME2ON]: Me2onSpecialOffer,
  [ESpecialOfferInternalViewModel.PIPA]: PipaSpecialOffer,
  [ESpecialOfferInternalViewModel.BABA]: BabaSpecialOffer,
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: PlaySimpleSpecialOffer,
  [ESpecialOfferInternalViewModel.GHOST]: ClassicVegasSlotsSpecialOffer,
  [ESpecialOfferInternalViewModel.GHOST_DOUBLE_HIT_CASINO]:
    DoubleHitCasinoSpecialOffer,
  [ESpecialOfferInternalViewModel.BINGO_POP]: BingoPopSpecialOffer,
  [ESpecialOfferInternalViewModel.ROYAL_MATCH]: RoyalMatchSpecialOffer,
  [ESpecialOfferInternalViewModel.FABEL_TOWN]: FabelTownSpecialOffer,
  [ESpecialOfferInternalViewModel.DECA]: DecaSpecialOffer,
  [ESpecialOfferInternalViewModel.LOAD_COMPLETE]: LoadCompleteSpecialOffer,
  [ESpecialOfferInternalViewModel.SPIN_X]: SpinXSpecialOffer,
  [ESpecialOfferInternalViewModel.CASH_FRENZY]: CashFrenzySpecialOffer,
  [ESpecialOfferInternalViewModel.GENNMU]: GennmuSpecialOffer,
  [ESpecialOfferInternalViewModel.BANDITOS]: BanditosSpecialOffer,
  [ESpecialOfferInternalViewModel.JUNES_JOURNEY]: JunesJourneySpecialOffer,
  [ESpecialOfferInternalViewModel.STUDIO_DEFAULT]: DefaultStudioSpecialOffer,
  [ESpecialOfferInternalViewModel.DRIMAGE]: DrimageSpecialOffer,
  [ESpecialOfferInternalViewModel.CASHMAN_CASINO]: CashmanCasinoSpecialOffer,
  [ESpecialOfferInternalViewModel.MIGHTY_FU]: MightyFuSpecialOffer
};

export const mapViewModelDisplayName: Record<
  ESpecialOfferInternalViewModel,
  string
> = {
  [ESpecialOfferInternalViewModel.HUGE]: 'Huge',
  [ESpecialOfferInternalViewModel.MATCH_MASTERS]: 'Match Masters',
  [ESpecialOfferInternalViewModel.POKER_FACE]: 'Poker Face',
  [ESpecialOfferInternalViewModel.BAGELCODE]: 'Bagelcode',
  [ESpecialOfferInternalViewModel.LOCO_BINGO]: 'Loco Bingo',
  [ESpecialOfferInternalViewModel.ME2ON]: 'Me2on',
  [ESpecialOfferInternalViewModel.PIPA]: 'Pipa',
  [ESpecialOfferInternalViewModel.BABA]: 'Baba',
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: 'Jackpot Slots',
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: 'Big Fish Casino',
  [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: 'Play Simple',
  [ESpecialOfferInternalViewModel.GHOST]: 'Ghost Studio Classic Vegas Slots',
  [ESpecialOfferInternalViewModel.GHOST_DOUBLE_HIT_CASINO]: 'Ghost Studio Double Hit Casino',
  [ESpecialOfferInternalViewModel.BINGO_POP]: 'Bingo Pop',
  [ESpecialOfferInternalViewModel.FABEL_TOWN]: 'Fabel Town',
  [ESpecialOfferInternalViewModel.DECA]: 'Deca',
  [ESpecialOfferInternalViewModel.LOAD_COMPLETE]: 'Load Complete',
  [ESpecialOfferInternalViewModel.SPIN_X]: 'Spinx JC',
  [ESpecialOfferInternalViewModel.CASH_FRENZY]: 'Spinx CF',
  [ESpecialOfferInternalViewModel.GENNMU]: 'Gennmu',
  [ESpecialOfferInternalViewModel.BANDITOS]: 'Banditos',
  [ESpecialOfferInternalViewModel.JUNES_JOURNEY]: 'Junes Journey',
  [ESpecialOfferInternalViewModel.STUDIO_DEFAULT]: 'Studio',
  [ESpecialOfferInternalViewModel.DRIMAGE]: 'Drimage',
  [ESpecialOfferInternalViewModel.CASHMAN_CASINO]: 'Cashman Casino',
  [ESpecialOfferInternalViewModel.MIGHTY_FU]: 'Mighty Fu',
  [ESpecialOfferInternalViewModel.ROYAL_MATCH]: 'Royal Match'
};
